module.exports = __webpack_public_path__ + "static/media/guestonline-1.1a1744c8.png";